<template>
  <b-row class="py-3" id="quotations-table">
    <b-col>
      <h2 class="tw-text-16px md:tw-text-18px color-brand-4 text-uppercase font-weight-bold pb-4 mt-4">Călător
        {{ index + 1 }}: <span class="font-weight-light">{{ traveler.firstName }} {{ traveler.lastName }}</span></h2>

      <b-collapse :visible="traveler.selectedQuotation !== null">
        <b-card border-variant="light" v-if="isMobile">
          <b-row v-if="traveler.selectedQuotation">
            <b-col class="p-0">
              <img style="max-height: 60px; max-width: 180px" :src="traveler.selectedQuotation.logo" alt="">
              <div class="text-muted mobile-text">Acoperire:</div>
              <div class="text-muted mobile-text">{{parseCountries(traveler.selectedQuotation.countries)}}</div>
              <a class="pl-0 mobile-text text-primary" :href="traveler.selectedQuotation.terms" target="_blank">DESCARCĂ CONDIȚII</a>
            </b-col>
            <b-col class="p-0 d-flex flex-column justify-content-center align-items-center">
              <h2 class="text-primary font-weight-medium mobile-price">
                {{ traveler.selectedQuotation.price }} {{ traveler.selectedQuotation.currency }}
              </h2>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-else>
          <b-row v-if="traveler.selectedQuotation">
            <b-col md="4">
              <div class="d-flex justify-content-center">
                <img style="max-height: 60px; max-width: 180px" :src="traveler.selectedQuotation.logo" alt="">
              </div>
            </b-col>

            <b-col md="4" class="py-2 d-flex justify-content-center align-items-center color-brand-4">
              <span><b>Acoperire</b> - {{parseCountries(traveler.selectedQuotation.countries)}}</span>
            </b-col>

            <b-col md="4">
              <b-row class="d-flex justify-content-center align-content-center">
                <h4 class="tw-text-18px color-brand-4 p-2 font-weight-bold">
                  <span class="tw-text-24px">{{ traveler.selectedQuotation.price }}</span> {{ traveler.selectedQuotation.currency }}
                </h4>
                <span class="fa fa-check-circle text-primary tw-text-24px m-2"></span>
              </b-row>
            </b-col>
          </b-row>
        </b-card>

        <b-btn class="color-brand-4" variant="link" @click="selectQuotation(null)">Alege altă ofertă</b-btn>
      </b-collapse>
      <b-collapse :visible="traveler.selectedQuotation === null">
        <div v-if="isMobile">
          <b-row class="my-3" v-for="quotation in quotationsAsArray[index]" :key="quotation.provider">
            <b-col class="p-0">
              <img style="max-height: 60px; max-width: 180px" :src="quotation.logo" alt="">
              <div class="text-muted mobile-text" v-if="!quotation.loading && !quotation.error">Acoperire:</div>
              <div class="text-muted mobile-text" v-if="!quotation.loading && !quotation.error">{{parseCountries(quotation.countries)}}</div>
              <a class="pl-0 mobile-text text-primary" v-if="!quotation.loading && !quotation.error" :href="quotation.terms" target="_blank">DESCARCĂ CONDIȚII</a>
            </b-col>
            <b-col class="p-0 d-flex flex-column justify-content-between">
              <div v-if="quotation.loading">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
                <div>Se incarcă...</div>
              </div>
              <div v-else-if="!quotation.error" class="pt-1">
                <h2 class="text-primary font-weight-medium mobile-price">
                  {{ quotation.price }} {{ quotation.currency }}
                </h2>
              </div>
              <div v-else>
                <div class="p-2">
                  <div :id="'popover-target-quotation-error-'+quotation.provider"
                       class="fa fa-exclamation-triangle text-danger" style="font-size: 24px;"></div>
                  <b-popover :target="'popover-target-quotation-error-'+quotation.provider" triggers="hover"
                             placement="auto" class="wide-popover">
                    <template #title>Ofertă indisponibilă</template>
                    <p v-if="traveler.coverages.storno">{{ quotation.error }}</p>
                    <p v-else>Asiguratorul nu cotează.</p>
                  </b-popover>
                </div>
              </div>
              <b-btn class="w-100 p-2" v-if="!quotation.loading && !quotation.error" variant="primary" @click="selectQuotation(quotation)" :disabled="!allQuotationsLoaded">+ Adaugă</b-btn>
            </b-col>
            <hr class="text-muted w-100 mt-3">
          </b-row>
        </div>
        <div v-else>
          <b-table responsive="md" stacked="sm" :fields="fields" :items="quotationsAsArray[index]" show-empty borderless no-border-collapse small >
            <template #empty="scope">
              <div class="text-center">Nu există oferte.</div>
            </template>

            <template #cell(logo)="data">
              <div class="d-flex justify-content-center px-2" >
                <img style="max-height: 60px; max-width: 180px" :src="data.item.logo" alt="">
              </div>
            </template>

            <template #cell(countries)="data">
              <div class="countries-wrap">
                {{parseCountries(data.item.countries)}}
              </div>
            </template>

            <template #cell(price)="data">
              <div v-if="data.item.loading">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
                <div>Se incarcă...</div>
              </div>
              <div v-else-if="!data.item.error" class="pt-1">
                <h4 class="price-wrap">
                  <span>{{ data.item.price }}</span> {{ data.item.currency }}
                </h4>
              </div>
              <div v-else>
                <div class="p-2">
                  <div :id="'popover-target-quotation-error-'+data.item.provider"
                       class="fa fa-exclamation-triangle text-danger" style="font-size: 24px;"></div>
                  <b-popover :target="'popover-target-quotation-error-'+data.item.provider" triggers="hover"
                             placement="auto" class="wide-popover">
                    <template #title>Ofertă indisponibilă</template>
                    <p v-if="traveler.coverages.storno">{{ data.item.error }}</p>
                    <p v-else>Asiguratorul nu cotează.</p>
                  </b-popover>
                </div>
              </div>
            </template>

            <template #cell(add)="data">
              <b-btn v-if="!data.item.loading && !data.item.error" class="bg-white color-brand-4 border-brand-3 btn-quotation-add" variant="primary" @click="selectQuotation(data.item)" :disabled="!allQuotationsLoaded">+ Adaugă</b-btn>
            </template>

            <template #cell(terms)="data">
              <b-btn v-if="!data.item.loading && !data.item.error" variant="link" :href="data.item.terms" class="color-brand-4" target="_blank">Descarcă</b-btn>
            </template>
          </b-table>
        </div>
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
import {mapGetters} from "vuex";
import {SET_SELECTED_QUOTATION} from "../store/travel.module";

export default {
  name: "QuotationsTable",
  props: ['index', 'traveler'],
  computed: {
    ...mapGetters(['travelers', 'providers', 'isLoggedIn', 'collector']),
    fields() {
      return [
        {label: 'Asigurator', key: 'logo', thClass: 'text-center color-brand-4', tdClass: 'text-center', thStyle: { minWidth: '100px' }},
        {label: 'Acoperire', key: 'countries', thClass: 'text-center color-brand-4', tdClass: 'text-center', thStyle: { minWidth: '100px' }},
        {label: 'Preț', key: 'price', thClass: 'text-center color-brand-4', tdClass: 'text-center', thStyle: { minWidth: '100px' }},
        {label: 'Adaugă oferta', key: 'add', thClass: 'text-center color-brand-4', tdClass: 'text-center', thStyle: { minWidth: '100px' }},
        {label: 'Condiții', key: 'terms', thClass: 'text-center color-brand-4', tdClass: 'text-center', thStyle: { minWidth: '100px' }},
      ]
    },
    allQuotationsLoaded() {
      let allLoaded = true;
      for(let i = 0; i < this.quotationsAsArray.length; i++) {
        for(let j = 0; j < this.quotationsAsArray[i].length; j++) {
          if (this.quotationsAsArray[i][j].loading) {
            allLoaded = false;
            break;
          }
        }
      }
      return allLoaded;
    },
    quotationsAsArray() {
      let quotations = [];
      for (let traveler of this.travelers) {
        if(!traveler.quotations) continue;
        let travelerQuotations = Object.keys(traveler.quotations).map(key => {
          return traveler.quotations[key]
        });

        // let travelerQuotations = [];
        // for (let provider of Object.keys(traveler.quotations)) {
        //   travelerQuotations.push(traveler.quotations[provider]);
        // }
        quotations.push(travelerQuotations);
      }

      return quotations;
    },
    isMobile() {
      return window.screen.width < 575.98;
    }
  },
  methods: {
    selectQuotation(quotation) {
      this.$store.commit(SET_SELECTED_QUOTATION, {index: this.index, quotation: quotation});
    },
    parseCountries(countries) {
      if (!countries) return '';

      if (countries.included && countries.included.length) {
        let ret = ''
        for (let idx in countries.included) {
          ret += countries.included[idx];
          if(idx != (countries.included.length - 1)) ret += ', ';
        }
        return ret;
      }

      if (countries.excluded && countries.excluded.length) {
        let ret = 'Toate tarile, mai putin: '
        for (let idx in countries.excluded) {
          ret += countries.excluded[idx];
          if(idx != (countries.excluded.length - 1)) ret += ', ';
        }
        return ret;
      }

      return '';
    }
  }
}
</script>

<style scoped>

.mobile-text {
  font-size: 11px;
}

.mobile-price {
  font-size: 1.6rem;
}

</style>
